import { API_REQUEST } from ".";
import {
  BlockUnblockReportAPI,
  getAllReportsAPI,
  sendWarningToUserEndPointURL,
} from "../../routes/apiEndPoints";
import { createAsyncThunk } from "@reduxjs/toolkit";

// get-all-reports
export const allReport = createAsyncThunk("get-all-reports", async () => {
  try {
    const response = await API_REQUEST({
      url: getAllReportsAPI,
      method: "GET",
    });
    return response;
  } catch (error) { }
});

//  blocked-Unblocked-Report
export const blockUnblockedReport = createAsyncThunk(
  "blocked-Unblocked-Report",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: BlockUnblockReportAPI,
        method: "POST",
        data: payload,
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);


export const warnToReportedUser = createAsyncThunk(
  "Warn-Reported-User",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: sendWarningToUserEndPointURL,
        method: "POST",
        data: payload,
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);